// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"33b7d1f5","455":"80c195b2"}[chunkId] + ".chunk.js";
};